import type { i18n } from 'i18next';
import { PluginContextServices } from 'shared/types';
import { eventsService } from './eventsService';
import { i18nLocalizationService, TParams } from './i18nLocalizationService';

export const resolveServices = (
    i18n: i18n,
    t: (key: string, params?: TParams) => string,
): PluginContextServices => ({
    logger: {
        // eslint-disable-next-line no-console
        log: console.log,
        warn: console.warn,
        error: console.error,
    },
    events: eventsService,
    localization: i18nLocalizationService({
        i18n,
        t,
        onLocaleChanged: () => eventsService.trigger('locale:changed'),
    }),
});
